<template>
  <div class="container">
    <div class="row">
      <h3 class="col-4 page-heading">Owner Info</h3>
    </div>
    <div class="signup-content">
      <h3>COMING SOON</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Company'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/profile/OwnerInfo.vue